import request from '../../../axios';

export const getMyChats = async (pageNumber: number) => {
  const {data}: {data: IMychats} = await request.get(
    `/api/v2/shop/chat?page=` + pageNumber,
  );
  return data;
};
